(function () {
  'use strict';

  if (window.safeDrapesAddonLoaded) return;
  window.safeDrapesAddonLoaded = true;

  var TEXT_ADDON = 47290626703529;
  var LOGO_ADDON = 47290679754921;

  console.log('SAFE DRAPES ADDON SCRIPT LOADED');

  function getProductForm() {
    var forms = document.querySelectorAll(
      'form[action*="/cart/add"]'
    );

    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="id"]')) {
        return forms[i];
      }
    }

    return null;
  }

  function getEmbroidery(form) {
    var field = form.querySelector(
      '[name="properties[Embroidery]"]'
    );

    if (!field || !field.value) {
      return '';
    }

    return field.value.toLowerCase();
  }

  function getProperties(form) {
    var properties = {};

    form.querySelectorAll(
      '[name^="properties["]'
    ).forEach(function (field) {

      var match = field.name.match(
        /^properties\[(.*)\]$/
      );

      if (match && field.value) {
        properties[match[1]] = field.value;
      }

    });

    return properties;
  }

  function addItems(form) {

    var embroidery =
      getEmbroidery(form);

    if (!embroidery) {
      return;
    }

    var id =
      form.querySelector('[name="id"]').value;

    var quantityField =
      form.querySelector('[name="quantity"]');

    var quantity =
      quantityField
        ? parseInt(quantityField.value, 10) || 1
        : 1;

    var properties =
      getProperties(form);

    var items = [
      {
        id: Number(id),
        quantity: quantity,
        properties: properties
      }
    ];

    if (
      embroidery.indexOf('text') !== -1
    ) {

      items.push({
        id: TEXT_ADDON,
        quantity: quantity,
        properties: {
          '_addon_for':
            'Safe Drapes Embroidery',
          '_embroidery_type':
            'Text',
          'Embroidery Text':
            properties['Embroidery Text'] || ''
        }
      });

    }

    if (
      embroidery.indexOf('icon') !== -1 ||
      embroidery.indexOf('logo') !== -1
    ) {

      items.push({
        id: LOGO_ADDON,
        quantity: quantity,
        properties: {
          '_addon_for':
            'Safe Drapes Embroidery',
          '_embroidery_type':
            'Logo',
          'Embroidery Logo':
            properties['Embroidery Logo'] || ''
        }
      });

    }

    console.log(
      'SAFE DRAPES ITEMS BEING ADDED:',
      items
    );

    return fetch(
      '/cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          'Accept':
            'application/json'
        },

        body: JSON.stringify({
          items: items
        })
      }
    );

  }


  /*
   * Capture the actual Add to Cart form
   * before Dawn processes it.
   */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;

      if (
        !form ||
        !form.matches ||
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }

      var embroidery =
        getEmbroidery(form);

      /*
       * No embroidery:
       * Dawn works normally.
       */

      if (!embroidery) {
        return;
      }

      console.log(
        'SAFE DRAPES EMBROIDERY SELECTED:',
        embroidery
      );

      event.preventDefault();
      event.stopImmediatePropagation();

      addItems(form)
        .then(function (response) {

          if (!response.ok) {
            throw new Error(
              'Shopify rejected the addon cart request.'
            );
          }

          return response.json();

        })
        .then(function () {

          console.log(
            'SAFE DRAPES ADDONS ADDED SUCCESSFULLY'
          );

          window.location.href =
            '/cart';

        })
        .catch(function (error) {

          console.error(
            'SAFE DRAPES ADDON ERROR:',
            error
          );

          alert(
            'Unable to add embroidery. Please try again.'
          );

        });

    },
    true
  );

})();